import { useHistory } from "react-router-dom";
import UserSession from "../../../models/session/user-session.entity";
import storageService from "../../../services/storage.service";

export const ProtectedRoute = ({ children }: any) => {
  const session = new UserSession(storageService.getObject('session') || {});
  const history = useHistory();

  if (!session.accessToken) {
    history.push('/login');
  }

  return children;
};
